module.exports = __webpack_public_path__ + "static/media/stocks.7a3777fb.svg";